module.exports = __webpack_public_path__ + "static/media/all-inclusive.26e93758.svg";